var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRouteStraight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6194 8.00212C12.1655 8.54942 13.052 8.55034 13.5993 8.00417C14.1466 7.458 14.1475 6.57157 13.6013 6.02427L8.00711 0.418475C7.46094 -0.128825 6.57451 -0.129743 6.02721 0.416424L0.421411 6.01062C-0.125889 6.55679 -0.126807 7.44322 0.41936 7.99052C0.965529 8.53782 1.85196 8.53874 2.39926 7.99257L5.61264 4.78584L5.60164 15.4059C5.60084 16.1791 6.22699 16.8066 7.00019 16.8074C7.77338 16.8082 8.40083 16.182 8.40164 15.4088L8.41263 4.78875L11.6194 8.00212Z",
    fill: "#200E32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRouteStraight);
export default __webpack_public_path__ + "static/media/icon-route-straight.2a93d0baa20a0aa31f8131388aafaac8.svg";
export { ForwardRef as ReactComponent };